var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetailsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#FEC400",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9988 13C16.0351 13 14.4626 13.8944 13.3179 14.9589C12.1805 16.0136 11.4198 17.2774 11.0602 18.145C10.9799 18.337 10.9799 18.5509 11.0602 18.7429C11.4198 19.6105 12.1805 20.8743 13.3179 21.9291C14.4626 22.9936 16.0351 23.8879 17.9988 23.8879C19.9625 23.8879 21.5349 22.9936 22.6796 21.9291C23.817 20.8719 24.5777 19.6105 24.9398 18.7429C25.02 18.5509 25.02 18.337 24.9398 18.145C24.5777 17.2774 23.817 16.0136 22.6796 14.9589C21.5349 13.8944 19.9625 13 17.9988 13ZM14.4991 18.444C14.4991 17.5158 14.8678 16.6256 15.5241 15.9693C16.1804 15.313 17.0706 14.9443 17.9988 14.9443C18.927 14.9443 19.8171 15.313 20.4734 15.9693C21.1298 16.6256 21.4985 17.5158 21.4985 18.444C21.4985 19.3721 21.1298 20.2623 20.4734 20.9186C19.8171 21.575 18.927 21.9437 17.9988 21.9437C17.0706 21.9437 16.1804 21.575 15.5241 20.9186C14.8678 20.2623 14.4991 19.3721 14.4991 18.444ZM17.9988 16.8886C17.9988 17.7465 17.3013 18.444 16.4434 18.444C16.2708 18.444 16.1055 18.4148 15.95 18.3638C15.8163 18.32 15.6608 18.4027 15.6657 18.5436C15.6729 18.7113 15.6972 18.879 15.7434 19.0467C16.0764 20.291 17.3572 21.0299 18.6015 20.6969C19.8458 20.3639 20.5847 19.0832 20.2517 17.8388C19.9819 16.8302 19.09 16.1522 18.0984 16.1108C17.9575 16.106 17.8748 16.2591 17.9186 16.3952C17.9696 16.5507 17.9988 16.716 17.9988 16.8886Z",
    fill: "url(#paint0_linear_366_7410)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_366_7410",
    x1: 11,
    y1: 13.7777,
    x2: 25.2771,
    y2: 14.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD4D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailsIcon);
export default __webpack_public_path__ + "static/media/details-icon.c46a99c9d2af366c33f3b5f0924c6159.svg";
export { ForwardRef as ReactComponent };